import React, { useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { navBarMenu } from '../supply-chain/nav-menu';

import { withNamespaces } from 'react-i18next';
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuTrigger,
  NavigationMenuContent,
  NavigationMenuLink,
  
} from '@shadcn/components/ui/navigation-menu';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@shadcn/components/ui/dropdown-menu';
import { useWebSocketToken } from '@helpers/JIFI/useWebSocketToken';
import useQuery from '@helpers/JIFI/useQuery';




const Navbar = (props) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem('authUser')) || {}
  );

  const token = useWebSocketToken()
  const location = useLocation();

  const fulfillmentRoutes = [
    '/orders',
    '/corp-orders',
    '/awaiting-stock',
    '/eiz',
    '/returns',
    '/order/create',
  ];

  
  const isActive = (routes) =>
    routes.some((route) => location.pathname.includes(route));

  const getDefaultNavItem = (type, permissions = []) => {
    const permission = permissions.find((val) =>
      user.permissions.includes(val)
    );
    return navBarMenu[type]?.find((val) => val.permission === permission);
  };


  const [isFulfillmentOpen, setFulfillmentOpen] = useState(false);
  const [isStockLevelOpen, setStockLevelOpen] = useState(false);
  const [isInventoryOpen, setInventoryOpen] = useState(false);
  const [isFinancialOpen, setFinancialOpen] = useState(false);
  const [isSettingsOpen, setSettingsOpen] = useState(false);


  const toggleFulfillment = () => setFulfillmentOpen(!isFulfillmentOpen);
  const toggleStockLevel = () => setStockLevelOpen(!isStockLevelOpen);
  const toggleInventory = () => setInventoryOpen(!isInventoryOpen);
  const toggleFinancial = () => setFinancialOpen(!isFinancialOpen);
  const toggleSettings = () => setSettingsOpen(!isSettingsOpen);

  const renderNavItem = React.useCallback(
    (permissions, label, path) => {
      if (!permissions || !Array.isArray(permissions) || permissions.length === 0 || 
          permissions.some(permission => user.permissions.includes(permission))) {
        return (
          <DropdownMenuItem asChild key={path}>
            <Link
              className="text-white ml-1 hover:text-gray-300 pl-6 !text-13px"
              to={path}
            >
              {label}
            </Link>
          </DropdownMenuItem>
        );
      }
      return null;
    },
    [user.permissions]
  );

  const renderDesktopNavItem = React.useCallback(
    (permissions, label, path, group, groupLabel) => {
      if (!permissions || !Array.isArray(permissions) || permissions.length === 0 ||
          permissions.some(permission => user.permissions.includes(permission))) {
        return (
          <li key={path}>
            <NavigationMenuLink
              className='block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-gray-900 min-w-[20vw]'
              asChild
            >
              <Link className="break-normal text-white" to={path}>
                {label}
              </Link>
            </NavigationMenuLink>
          </li>
        );
      }
      return null;
    },
    [user.permissions]
  );

  const fulfilmentMenuItems = React.useMemo(
    () => [
      { permissions: null, label: 'Ecommerce Orders', path: '/orders' },
      { permissions: null, label: 'Corporate Orders', path: '/corp-orders' },
      { permissions: null, label: 'EIZ Manifests', path: '/eiz' },
      {
        permissions: ['CreateOrder'],
        label: 'Create Order',
        path: '/order/create',
      },
      {
        permissions: null,
        label: 'Personalisation Batches',
        path: getDefaultNavItem('fulfillment-location', ['UNISPersonalisation', 'LaunchPersonalisation', 'ViewOrders', 'AirboxPersonalisation'])?.url,
      },
      { permissions: null, label: 'Tickets', path: '/tickets/warranty' },
      { permissions: null, label: 'Order Report', path: '/order-report/mispick' },
      
    ],
    []
  );


  const stockMenuItems = React.useMemo(
    () => [
      {
        permissions: ['ViewTotalCount'],
        label: 'Total Stock',
        path: '/all-stock',
      },
      {
        permissions: ['ViewTotalCount'],
        label: 'Total Stock New',
        path: '/all-stock-new',
      },
      {
        permissions: ['ViewTotalCount'],
        label: 'Stock Allocation',
        path: '/stock-allocation',
      },
      {
        permissions: ['ViewContainer'],
        label: 'Upcoming Containers',
        path: '/upcoming-container',
      },
      {
        permissions: ['ViewTotalCount'],
        label: 'Stock Warnings',
        path: '/stock-warning',
      },
      {
        permissions: ['ViewOrders'],
        label: 'Awaiting Stock Summary',
        path: '/awaiting-stock',
      },
      {
        permissions: ['ViewTotalCount'],
        label: 'Stockout Report',
        path: '/stock/stockout-report',
      }
    ],
    []
  );

  const inventoryMenuItems = React.useMemo(
    () => [
      { permissions: ['CreateApproval'], label: 'Stock Audit', path: '/stock' },
      {
        permissions: ['TransferStock'],
        label: 'Transfer Stock',
        path: '/stock/transfer',
      },
      {
        permissions: ['BookStockDrop'],
        label: 'Store Replenishments',
        path: '/stock/replenish',
      },
      // {
      //   permission: 'BookStockDrop',
      //   label: 'Warehouse Transfers',
      //   path: '/stock/warehouse-transfer',
      // },
      {
        permissions: ['ViewMovementHistory'],
        label: 'Movement History',
        path: '/movement-history',
      },
      {
        permissions: ['ViewDualInventory'],
        label: 'Dual Inventory',
        path: '/dual-inventory',
      },

      {
        path:'/stock/inventory-accuracy',
        label:'Inventory Accuracy Report',
      }
    ],
    []
  );

  const financeMenuItems = React.useMemo(() => [
    
    { permissions: ['ViewApprovals'], label: 'Audit Approvals', path: '/approvals', group: 'operations' },
    { permissions: ['ViewDemand'], label: 'Forecast', path: '/forecast', group: 'operations' },
    { permissions: ['ViewDemand'], label: 'Historic Stock Status', path: '/demand/stock-status', group: 'operations' },
    { permissions: ['ViewDemand'], label: 'Historic Stock Status Months', path: '/demand/stock-status-month', group: 'operations' },
    { permissions: ['ViewDemand'], label: 'Mis-Picked Orders', path: '/mispick-stock', group: 'operations' },
    { permissions: ['ViewOrders'], label: 'Nested Orders Report', path: '/nested-orders', group: 'operations' },
    
    { permissions: [], label: 'Forecast Month Stock', path: '/forecast-month-stock', group: 'report' },
    { permissions: [], label: 'Weekly Sales', path: '/weekly-sales', group: 'report' },
    { permissions: [], label: 'Sale State Report', path: '/sale-state', group: 'report' },
    { permissions: [], label: 'Top & Bottom Sales', path: '/top-bottom-report', group: 'report' },
    { permissions: [], label: 'Category performance', path: '/category-performance', group: 'report' },
    { permissions: [], label: 'SOH Details', path: '/soh-details', group: 'report' },
    { permissions: [], label: 'Ticket Dashboard', path: '/ticket-dashboard', group: 'report' },
    
  ], []);


  const settingMenuItems = React.useMemo(() => [
    { permissions: ['EditProductVariant'], label: 'Products', path: '/product/all', group: 'management' },
    { permissions: ['EditLocations'], label: 'Locations', path: '/location/all', group: 'management' },
    { permissions: ['EditUser'], label: 'Users', path: '/users/all', group: 'management' },
    { permissions: ['EditReturns'], label: 'Parcels', path: '/parcels', group: 'management' },
    { permissions: ['ViewFactories'], label: 'Factories', path: '/factories', group: 'management' },
    { permissions: null, label: 'Categories', path: '/category/all', group: 'management' },
    { permissions: ['ViewPurchaseOrders'], label: 'Purchase Orders', path: '/purchase-order', group: 'management' },
    { permissions: ['ViewErrorLog'], label: 'Error Logs', path: '/error-logs/all', group: 'management' },
    { permissions: [], label: 'IP Logs', path: '/ip-logs/all', group: 'management' },
    { permissions: ['ViewCarrierPerformance'], label: 'Carrier Performance', path: '/carrier-performance', group: 'management' },
    { permissions: null, label: 'Shipment Analytics', path: '/shipment-analytic', group: 'management' },
    
    { permissions: [], label: 'Region Configs', path: '/region-configs/list', group: 'config' },
    { permissions: ["ManageAmazonSellerConfigs"], label: 'Amazon Seller Configs', path: '/amazon-seller-configs', group: 'config' },
    { permissions: null, label: 'Location Order Config', path: '/location-order-config', group: 'config' },
    { permissions: ['ViewFeatureFlags', 'ManageFeatureFlags'], label: 'Feature Flags', path: '/feature-flags', group: 'config' },
    { permissions: ['ViewNestingRules', 'ManageNestingRules'], label: 'Nesting Rules', path: '/nesting-rules', group: 'config' },
    { permissions: ['ViewSkuMapping', 'EditSkuMapping'], label: 'SKU Mapping', path: '/sku/all', group: 'config' },
    { permissions: ['ViewAutomations'], label: 'Automate Workflows', path: '/automation-engine', group: 'config' },
  ], []);

  return (
    <div style={{  top: 0 }} className="hidden lg:block bg-black">
      <div>
        <nav
          className="navbar navbar-light navbar-expand-lg topnav-menu py-[7px]"
          id="navigation"
        >
          <DropdownMenu
            modal={false}
            className="hidden lg:block"
            open={props.menuOpen}
            
          >
            <DropdownMenuTrigger className="sm:hidden text-white  duration-300">
              
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="start"
              className="lg:hidden bg-black p-4 shadow-lg rounded-lg max-h-64 !overflow-y-auto w-[100vw] fixed top-[70px]"
            >
              <ul>
                {/* Dashboard */}
                <DropdownMenuItem asChild>
                  <Link
                    className={`text-white hover:text-gray-300 `}
                    to="/dashboard"
                  >
                    
                    {props.t('Dashboard')}
                  </Link>
                </DropdownMenuItem>

                {/* Fulfillment Dropdown - Mobile */}
                {(user.permissions.includes('ViewOrders') ||
                  user.permissions.includes('ViewDeliveries') ||
                  user.permissions.includes('CreateOrder') ||
                  user.permissions.includes('UNISPersonalisation') ||
                  user.permissions.includes('AirboxPersonalisation')) && (
                  <>
                    
                    {/* Fulfillment toggle */}
                    <DropdownMenuItem
                      asChild
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <div
                        className="text-white  hover:text-gray-300 flex justify-between items-center cursor-pointer"
                        onClick={toggleFulfillment}
                      >
                        <span>
                          Fulfillment
                        </span>
                        <i
                          className={`bx ${
                            isFulfillmentOpen
                              ? 'bx-chevron-up'
                              : 'bx-chevron-down'
                          }`}
                        ></i>
                      </div>
                    </DropdownMenuItem>

                    {/* Sub-menu for Fulfillment */}
                    {isFulfillmentOpen && (
                      fulfilmentMenuItems.map(({ permissions, label, path }) =>
                        renderNavItem(permissions, label, path)
                      )
                    )}
                  </>
                )}

                {/* Total Stock Mobile */}

                {(user.permissions.includes('ViewTotalCount') ||
                  user.permissions.includes('ViewOrders') ||
                  user.permissions.includes('ViewContainer')) && (
                  <>
                    {/* Total Stock toggle */}
                    <DropdownMenuItem
                      asChild
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <div
                        className="text-white  hover:text-gray-300 flex justify-between items-center cursor-pointer"
                        onClick={toggleStockLevel}
                      >
                        <span>
                         Stock Levels
                        </span>
                        <i
                          className={`bx ${
                            isStockLevelOpen
                              ? 'bx-chevron-up'
                              : 'bx-chevron-down'
                          }`}
                        ></i>
                      </div>
                    </DropdownMenuItem>

                    {/* Sub-menu for Stock Levels */}
                    {isStockLevelOpen && (
                        stockMenuItems.map(({ permissions, label, path }) =>
                            renderNavItem(permissions, label, path)
                        )
                    )}
                  </>
                )}

                {/* Inventory Mobile */}

                {(user.permissions.includes('CreateApproval') ||
                  user.permissions.includes('TransferStock') ||
                  user.permissions.includes('BookStockDrop') ||
                  user.permissions.includes('ViewMovementHistory') ||
                  user.permissions.includes('ViewDualInventory')) && (
                  <>
                    {/* Inventory toggle */}
                    <DropdownMenuItem
                      asChild
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <div
                        className="text-white  hover:text-gray-300 flex justify-between items-center cursor-pointer"
                        onClick={toggleInventory}
                      >
                        <span>
                          Inventory
                        </span>
                        <i
                          className={`bx ${
                            isStockLevelOpen
                              ? 'bx-chevron-up'
                              : 'bx-chevron-down'
                          }`}
                        ></i>
                      </div>
                    </DropdownMenuItem>

                    {/* Sub-menu for Inventory*/}
                    {isInventoryOpen && (
                        inventoryMenuItems.map(({ permissions, label, path }) =>
                            renderNavItem(permissions, label, path)
                        )   
                    )}
                  </>
                )}


                {/* Financial Mobile */}

                {(user.permissions.includes('ViewApprovals') ||
                  user.permissions.includes('CreateASN') ||
                  user.permissions.includes('ViewDemand')) && (
                  <>
                    {/* Financial toggle */}
                    <DropdownMenuItem
                      asChild
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <div
                        className="text-white  hover:text-gray-300 flex justify-between items-center cursor-pointer"
                        onClick={toggleFinancial}
                      >
                        <span>
                          Financial
                        </span>
                        <i
                          className={`bx ${
                            isStockLevelOpen
                              ? 'bx-chevron-up'
                              : 'bx-chevron-down'
                          }`}
                        ></i>
                      </div>
                    </DropdownMenuItem>

                    {/* Sub-menu for Financial*/}
                    {isFinancialOpen && (
                      <>
                        
                        <DropdownMenuItem asChild className="font-medium text-white">
                          <div className="text-white hover:text-gray-300 pl-6 !text-13px pt-2 pb-1">Operations</div>
                        </DropdownMenuItem>
                        {financeMenuItems
                          .filter(item => item.group === 'operations')
                          .map(({ permissions, label, path }) =>
                            renderNavItem(permissions, label, path, null, null)
                          )
                        }

                        
                        <DropdownMenuItem asChild className="font-medium text-white mt-2">
                          <div className="text-white hover:text-gray-300 pl-6 !text-13px pt-2 pb-1 border-t border-gray-700">Reports</div>
                        </DropdownMenuItem>
                        {financeMenuItems
                          .filter(item => item.group === 'report')
                          .map(({ permissions, label, path }) =>
                            renderNavItem(permissions, label, path, null, null)
                          )
                        }
                      </>
                    )}
                  </>
                )}



                {/* Setting Mobile */}

                {(
                 user.permissions.includes('EditProductVariant') ||
                  user.permissions.includes('EditLocations') ||
                  user.permissions.includes('EditUser') ||
                  user.permissions.includes('ViewFactories') ||
                  user.permissions.includes('ViewPurchaseOrders')) && (
                  <>
                    {/* Setting toggle */}
                    <DropdownMenuItem
                      asChild
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <div
                        className="text-white  hover:text-gray-300 flex justify-between items-center cursor-pointer"
                        onClick={toggleSettings}
                      >
                        <span>
                          Settings
                        </span>
                        <i
                          className={`bx ${
                            isStockLevelOpen
                              ? 'bx-chevron-up'
                              : 'bx-chevron-down'
                          }`}
                        ></i>
                      </div>
                    </DropdownMenuItem>

                    {/* Sub-menu for Setting*/}
                    {isSettingsOpen && (
                        settingMenuItems.map(({ permissions, label, path }) =>
                            renderNavItem(permissions, label, path)
                        )   
                    )}
                  </>
                )}
              </ul>
            </DropdownMenuContent>
          </DropdownMenu>
          {/* desktop */}
          <NavigationMenu  className="hidden md:flex">
            <NavigationMenuList className="flex flex-row py-2">
              <NavigationMenuItem>
                <Link
                  className={`text-white bg-transparent  px-3 text-[14px] ${location.pathname === '/dashboard' ? 'opacity-90' : 'opacity-60'}`}
                  to="/dashboard"
                >
                  
                  {props.t('Dashboard')}
                </Link>
              </NavigationMenuItem>

              {/* Fulfillment Menu */}
              {(user.permissions.includes('ViewOrders') ||
                user.permissions.includes('ViewDeliveries') ||
                user.permissions.includes('CreateOrder') ||
                user.permissions.includes('UNISPersonalisation') ||
                user.permissions.includes('AirboxPersonalisation')) && (
                <NavigationMenuItem  className="bg-transparent">
                  <NavigationMenuTrigger
                  
                    className={`text-white bg-transparent font-normal px-3 
                      ${isActive(fulfilmentMenuItems.map(({ path }) => path)) ? 'opacity-90' : 'opacity-60'}`}
                    style={{  }}
                  >
                     Fulfillment
                  </NavigationMenuTrigger>
                  <NavigationMenuContent  className=" bg-black p-4 shadow-lg rounded-lg  left-0">
                    <ul className="">
                      {fulfilmentMenuItems.map(({ permissions, label, path }) =>
                        renderDesktopNavItem(permissions, label, path, null, null)
                      )}
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              )}

              {/* Stock Levels Menu */}
              {(user.permissions.includes('ViewTotalCount') ||
                user.permissions.includes('ViewOrders') ||
                user.permissions.includes('ViewContainer')) && (
                <NavigationMenuItem>
                  <NavigationMenuTrigger
                    className={`text-white bg-transparent font-normal px-3
                         ${isActive(stockMenuItems.map(({ path }) => path)) ? 'opacity-90' : 'opacity-60'}`}
                    style={{  }}
                  >
                     Stock Levels
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-black p-4 shadow-lg rounded-lg w-fit left-0">
                    <ul className="w-fit">
                      {stockMenuItems.map(({ permissions, label, path }) =>
                        renderDesktopNavItem(permissions, label, path, null, null)
                      )}
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              )}

              {/* Inventory Menu */}
              {(user.permissions.includes('CreateApproval') ||
                user.permissions.includes('TransferStock') ||
                user.permissions.includes('BookStockDrop') ||
                user.permissions.includes('ViewMovementHistory') ||
                user.permissions.includes('ViewDualInventory')) && (
                <NavigationMenuItem>
                  <NavigationMenuTrigger
                     className={`text-white opacity-60 bg-transparent font-normal px-3
                      ${isActive(inventoryMenuItems.map(({ path }) => path)) ? 'opacity-90' : 'opacity-60'}`}
                    style={{  }}
                  >
                     Inventory
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-black p-4 shadow-lg rounded-lg left-0">
                    <ul className="">
                      {inventoryMenuItems.map(({ permissions, label, path }) =>
                        renderDesktopNavItem(permissions, label, path, null, null)
                      )}
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              )}

              {/* Finance Menu */}
              {(user.permissions.includes('ViewApprovals') ||
                user.permissions.includes('CreateASN') ||
                user.permissions.includes('ViewDemand')) && (
                <NavigationMenuItem>
                  <NavigationMenuTrigger
                    className={`text-white opacity-60 bg-transparent  font-normal px-3
                         ${isActive(financeMenuItems.map(({ path }) => path)) ? 'opacity-90' : 'opacity-60'}`}
                    style={{  }}
                  >
                     Finance
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-black p-4 shadow-lg rounded-lg left-0">
                    <div className="max-h-[70vh] overflow-y-auto">
                      <div className="grid grid-cols-2 gap-6 w-[600px]">
                        
                        <div>
                          <h3 className="text-white font-medium mb-3 pb-1">Operations</h3>
                          <ul className="space-y-0.5">
                            {financeMenuItems
                              .filter(item => item.group === 'operations')
                              .map(({ permissions, label, path }) =>
                                renderDesktopNavItem(permissions, label, path, null, null)
                              )
                            }
                          </ul>
                        </div>
                        
                        
                        <div>
                          <h3 className="text-white font-medium mb-3 pb-1">Reports</h3>
                          <ul className="space-y-0.5">
                            {financeMenuItems
                              .filter(item => item.group === 'report')
                              .map(({ permissions, label, path }) =>
                                renderDesktopNavItem(permissions, label, path, null, null)
                              )
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              )}

              {/* Settings Menu */}
              {(user.permissions.includes('EditProductVariant') ||
                user.permissions.includes('EditLocations') ||
                user.permissions.includes('EditUser') ||
                user.permissions.includes('ViewFactories') ||
                user.permissions.includes('ViewPurchaseOrders')) && (
                <NavigationMenuItem>
                  <NavigationMenuTrigger
                    className={`text-white opacity-60 bg-transparent  font-normal px-3
                         ${isActive(settingMenuItems.map(({ path }) => path)) ? 'opacity-90' : 'opacity-60'}`}
                    style={{  }}
                  >
                    Settings
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-black p-4 shadow-lg rounded-lg left-0">
                    <div className="max-h-[70vh] overflow-y-auto">
                      <div className="grid grid-cols-2 gap-6 w-[600px]">
                        
                        <div>
                          <h3 className="text-white font-medium mb-3 pb-1">Management</h3>
                          <ul className="space-y-0.5">
                            {settingMenuItems
                              .filter(item => item.group === 'management')
                              .map(({ permissions, label, path }) =>
                                renderDesktopNavItem(permissions, label, path, null, null)
                              )
                            }
                          </ul>
                        </div>
                        
                        
                        <div>
                          <h3 className="text-white font-medium mb-3 pb-1">Config</h3>
                          <ul className="space-y-0.5">
                            {settingMenuItems
                              .filter(item => item.group === 'config')
                              .map(({ permissions, label, path }) =>
                                renderDesktopNavItem(permissions, label, path, null, null)
                              )
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              )}
            </NavigationMenuList>
            
          </NavigationMenu>
        </nav>
      </div>
    </div>
  );
};

export default withNamespaces()(Navbar);
